import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/base_components/ui/accordion'

import styles from './index.module.scss'

const FAQ: React.FC<FAQsPanelProps> = ({ title, FAQsData }) => {
  const headerTitle = title || 'FAQs'

  return (
    <div className={styles.FAQ}>
      <div className={styles.FAQ__container}>
        <h2 className={styles.FAQ__heading}>{headerTitle}</h2>
        <div>
          <div className={styles.FAQ__line}></div>
          <Accordion type="single" collapsible defaultValue="0">
            {FAQsData.map((item, index) => (
              <AccordionItem
                key={item.id}
                value={index.toString()}
                className={styles.FAQ__card}
              >
                <AccordionTrigger
                  className={`${styles.FAQ__card_header} ~no-underline hover:~no-underline`}
                >
                  <span className={styles.FAQ__question}>{item.question}</span>
                </AccordionTrigger>
                <AccordionContent className={styles.FAQ__answer}>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.answer,
                    }}
                  />
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  )
}

export default FAQ
